import { render } from "./ForgetAboutMeWithToken.vue?vue&type=template&id=bba8a5f0"
import script from "./ForgetAboutMeWithToken.vue?vue&type=script&lang=js"
export * from "./ForgetAboutMeWithToken.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__